import { Box, Button, Typography } from "@mui/material";
import { LOGIN_PAGE_URL, MY_APP_URL } from "@/config";

const OutOfContractPeriod = () => {
  const handleClose = () => {
    window.location.replace(`${LOGIN_PAGE_URL}?redirect=${MY_APP_URL}/views/`);
  };

  return (
    <Box
      sx={{
        padding: "50px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Typography variant="body1" gutterBottom>
        RECERQA Scanのご利用ありがとうございました。
      </Typography>
      <Typography variant="body1" gutterBottom>
        ご意見・ご要望や継続利用は以下よりご連絡ください。
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          mt: "20px",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          sx={{
            borderRadius: "20px",
            width: "200px",
          }}
          onClick={handleClose}
        >
          閉じる
        </Button>
        <Button
          variant="contained"
          color="primary"
          component="a"
          href="mailto:info@recerqa.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            borderRadius: "20px",
            width: "200px",
          }}
        >
          CONTACT
        </Button>
      </Box>
    </Box>
  );
};

export default OutOfContractPeriod;
